import { Button, Drawer, Image } from "antd";
import { ReactNode } from "react";
import CloseIcon from "../../assets/icons/CloseIcon";
import placeholder from "../../assets/images/placeholder.png";

type Props = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
  subtitle?: string;
  image?: string;
  closeable?: boolean;
  size?: number;
};

const CustomDrawer = ({
  open,
  onClose,
  title,
  subtitle,
  image,
  closeable = true,
  children,
  size = 420,
}: Props) => {
  return (
    <Drawer
      getContainer={false}
      destroyOnClose
      title={
        <div className="flex gap-2.5 justify-between">
          <div className="flex items-center gap-2.5">
            {image && (
              <Image
                height={40}
                width={40}
                preview={false}
                className="rounded-full"
                src={image || placeholder}
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).src = placeholder;
                }}
              />
            )}
            <div>
              {title && (
                <h5 className="text-lg font-medium text-theme-gray-24">
                  {title}
                </h5>
              )}
              {subtitle && (
                <p className="text-xs font-normal text-theme-gray-40">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {closeable && (
            <Button
              onClick={onClose}
              size="small"
              className="border-none shadow-none size-7"
            >
              <CloseIcon />
            </Button>
          )}
        </div>
      }
      placement="right"
      onClose={onClose}
      open={open}
      width={size}
      closable={false}
    >
      {children}
    </Drawer>
  );
};

export default CustomDrawer;
